import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog, TableBodySkeleton } from '../../common/components';
import SubscribersDataTable from './components/SubscribersDataTable';
import SubscribersPagination from './components/SubscribersPagination';
import SubscriberDialog from './components/SubscriberDialog';
import { useSubscribersTable } from './hooks/useSubscribersTable';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const SubscribersTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    editMode,
    selectedSubscriber,
    nationalities,
    maritalStatuses,
    ivaConditions,
    countries,
    provinces,
    departments,
    districts,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSelectChange,
    handleSave,
    handleEdit,
    handleDelete,
    deleteConfirmOpen,
    subscriberToDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useSubscribersTable();

  return (
    <Box>
      <FormTitleBox
        title="Entidades | Suscriptores"
        showButton={true}
        buttonText="Agregar Suscriptor"
        buttonIcon={PersonAddIcon}
        onButtonClick={handleOpenDialog}
        showSearch={true}
        searchLabel="Buscar suscriptor"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <SubscribersDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        districts={districts}
        LoadingComponent={TableBodySkeleton}
      />

      <SubscribersPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <SubscriberDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedSubscriber={selectedSubscriber}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
        nationalities={nationalities}
        maritalStatuses={maritalStatuses}
        ivaConditions={ivaConditions}
        countries={countries}
        provinces={provinces}
        departments={departments}
        districts={districts}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        entityName="suscriptores"
        message={`¿Está seguro que quiere eliminar al suscriptor "${subscriberToDelete?.first_name} ${subscriberToDelete?.last_name}" de forma permanente?`}
      />
    </Box>
  );
};

export default SubscribersTable;
